<template>
    <template v-if="product.filters.length">
        <p>{{ $t('aiGeneration.modal.description') }}</p>
        <p>{{ $t('aiGeneration.modal.conditionsDescription') }}</p>
        <ul class="list">
            <li>{{ $t('aiGeneration.modal.nameCondition') }}</li>
            <li>{{ $t('aiGeneration.modal.seoCondition') }}</li>
            <li>{{ $t('aiGeneration.modal.descriptionCondition') }}</li>
        </ul>
        <p>{{ $t('aiGeneration.modal.exampleDescription') }}</p>
        <p>{{ $t('aiGeneration.modal.systemDescription') }}</p>
        <div class="row mt-3">
            <div class="col-lg-6">
                <FormGroup :label="$t('aiGeneration.fieldsSelection.title')">
                    <AppMultiselect
                        @update:model-value="$emit('update:generation-fields', $event)"
                        :model-value="generationFields"
                        :options="generationFieldsOptions"
                        option-key="key"
                        option-value="label"
                        :disabled-fields="disabledForGenerationFields"
                    />
                    <span class="form-text text-muted">{{ $t('aiGeneration.fieldsSelection.description') }}</span>
                </FormGroup>
            </div>
            <div class="col-lg-6">
                <FormGroup :label="$t('aiGeneration.fieldsSelection.excludeFiltersTitle')">
                    <AppMultiselect
                        @update:model-value="$emit('update:filters-who-need-exclude', $event)"
                        :model-value="filtersWhoNeedExclude"
                        :options="filtersOptions"
                        option-key="key"
                        option-value="value"
                    />
                    <span class="form-text text-muted">{{ $t('aiGeneration.fieldsSelection.excludeFiltersDescription') }}</span>
                </FormGroup>
            </div>
        </div>
    </template>
    <template v-else>
        <div class="alert alert-warning">
            {{ $t('aiGeneration.modal.requirementsWarning') }}
        </div>
    </template>
</template>
<script>
import InputGroup from "../../../../../components/new/form/InputGroup.vue";
import AppCheckbox from "../../../../../components/new/form/checkbox/AppCheckbox.vue";
import AppMultiselect from "../../../../../components/new/form/autocomplete/AppMultiselect.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";

export default {
    name: 'FieldSelectionScreen',
    components: {
        InputGroup, AppCheckbox, AppMultiselect, FormGroup
    },
    props: {
        product: {
            type: Object,
            required: true
        },
        filtersWhoNeedExclude: {
            type: Array,
            default: () => []
        },
        mainIntegrationLanguage: {
            type: String,
            required: true
        },
        generationFields: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            generationFieldsOptions: [
                {key: 'nameGenerationStep', label: this.$t('aiGeneration.fields.name')},
                {key: 'keywordGenerationStep', label: this.$t('aiGeneration.fields.seo')},
                {key: 'descriptionGenerationStep', label: this.$t('aiGeneration.fields.description')},
            ]
        }
    },
    methods: {
        getNameString(names) {
            return names[this.mainIntegrationLanguage] ?? Object.values(names)[0] ?? '';
        }
    },
    computed: {
        allowGenerateSeo() {
            return Object.keys(this.product.names).length || 
                this.generationFields.some(field => field.key === 'nameGenerationStep');
        },
        allowGenerateDescription() {
            return (Object.keys(this.product.names).length ||
                this.generationFields.some(field => field.key === 'nameGenerationStep')) &&
                (Object.keys(this.product.seos).length ||
                this.generationFields.some(field => field.key === 'keywordGenerationStep'));
        },
        filtersOptions() {
            return this.product.filters.map(filter => {
                return {
                    key: filter.uuid,
                    value: this.getNameString(filter.names)
                }
            });
        },
        disabledForGenerationFields() {
            const disabledFields = [];
            
            if (!this.allowGenerateSeo) {
                disabledFields.push('keywordGenerationStep');
            }

            if (!this.allowGenerateDescription) {
                disabledFields.push('descriptionGenerationStep');
            }

            return disabledFields;
        }
    }
}
</script>  